import selfcheckFactory from './selfcheck-factory';

const selfcheck = selfcheckFactory(DN_YEAR);

export default selfcheck;



// WEBPACK FOOTER //
// ./src/js/store/modules/selfcheck/index.js